import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAgencyAssociatedRecords, getAgencyCallLog, getAgencyCallLogs } from './api';
import { AgencyCallLogResponse, AssociatedRecordResponse } from './types';

type CallLogsQueryOptions = Omit<
  UseQueryOptions<{ data: AgencyCallLogResponse[]; meta: MetaApiResponse }, Error>,
  'queryKey' | 'queryFn'
>;
type CallLogQueryOptions = Omit<UseQueryOptions<AgencyCallLogResponse, Error>, 'queryKey' | 'queryFn'>;

export function useGetAgencyCallLogs(params?: Record<string, any>, options?: CallLogsQueryOptions) {
  return useQuery<{ data: AgencyCallLogResponse[]; meta: MetaApiResponse }>({
    queryKey: ['agency_call_logs', params],
    queryFn: () => getAgencyCallLogs(params),
    ...options
  });
}

export function useGetAgencyCallLog(
  id: string | undefined,
  params?: Record<string, any>,
  options?: CallLogQueryOptions
) {
  return useQuery<AgencyCallLogResponse>({
    queryKey: ['agency_call_log', id, params],
    queryFn: () => getAgencyCallLog(id!, params),
    enabled: Boolean(id),
    ...options
  });
}

export function useGetAgencyAssociatedRecords(
  interactionId?: number,
  contactId?: number,
  params?: Record<string, any>,
  options?: UseQueryOptions<{ integration_entity_contacts: AssociatedRecordResponse[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ integration_entity_contacts: AssociatedRecordResponse[]; meta: MetaApiResponse }>({
    queryKey: ['agency_associated_records', interactionId, contactId, params],
    queryFn: () => getAgencyAssociatedRecords(interactionId!, contactId!, params),
    enabled: Boolean(interactionId && contactId),
    ...options
  });
}
